<template>
  <header
    class="fixed top-0 inset-x-0 z-40 w-full flex-none text-sm font-semibold leading-6 bg-white/80 backdrop-blur-sm shadow"
  >
    <nav aria-label="Global" class="container">
      <div class="relative flex items-center">
        <div class="absolute inset-y-0 right-full w-[50vw] bg-primary" />
        <a href="/" class="mr-auto flex-none text-slate-900 relative">
          <the-logo class="sm:h-navbar" />
        </a>

        <div class="hidden lg:flex lg:items-center">
          <template v-for="link in links" :key="link.id">
            <div
              v-if="link.submenu"
              class="relative rounded-md py-2 px-4 text-sm text-slate-700 cursor-pointer"
              :class="{
                'bg-primary text-white': activeLink == link.id
              }"
              @mouseenter="showSubmenu"
              @mouseleave="hideSubmenu"
            >
              {{ link.text }}
              <ul
                v-if="submenuVisible"
                class="absolute left-0 w-[260px] mt-2 bg-white shadow-lg rounded-md p-2"
              >
                <li v-for="item in link.submenu" :key="item.id">
                  <a
                    href="#"
                    class="block rounded-md py-2 px-4 text-sm text-slate-700 cursor-pointer hover:bg-secondary"
                    @click.prevent="openAndScroll(item.href)"
                  >
                    {{ item.text }}
                  </a>
                </li>
              </ul>
            </div>

            <router-link
              v-else
              :to="'/' + link.href"
              class="block rounded-md py-2 px-4 text-sm text-slate-700 cursor-pointer"
              :class="{
                'bg-primary text-white pointer-events-none': activeLink === link.id
              }"
            >
              {{ link.text }}
            </router-link>
          </template>
        </div>

        <burger-menu
          :links="links"
          class="lg:hidden !absolute xs:!relative top-1/2 -right-2 -mt-4 xs:mt-0"
        />
      </div>
    </nav>
  </header>
</template>

<script setup>
import { ref } from 'vue';
import TheLogo from './TheLogo.vue';
import BurgerMenu from './BurgerMenu.vue';
import { useRouter } from 'vue-router';

defineProps({
  activeLink: {
    type: String,
    default: null
  }
});

const links = [
  { id: 'processes', text: 'Processes', href: '#processes' },
  {
    id: 'services',
    text: 'Digital Twin Services',
    href: '#services',
    submenu: [
      { id: 'cobie', text: 'Digital Data (COBie) Cleaning', href: '#cobie' },
      { id: 'm3d', text: '3D Model Cleaning & Preparation', href: '#m3d' },
      { id: 'lofd', text: 'Level of Detail', href: '#lofd' },
      { id: 'dasd', text: 'Digital Asset & Systems Delivery', href: '#dasd' },
      { id: 'dta', text: 'Digital Twin Assessment', href: '#dta' },
      { id: 'iot', text: 'IoT Sensor Integration', href: '#iot' }
    ]
  },
  { id: 'for-modular', text: 'BIM for Modular', href: '#for-modular' },
  { id: 'partners', text: 'Partners & Clients', href: '#partners' },
  { id: 'about', text: 'About', href: '#about' },
  { id: 'contacts', text: 'Contact Us', href: '#contacts' }
];

const router = useRouter();

const submenuVisible = ref(false); // NOTE: if more than one submenu, use an object

function showSubmenu() {
  submenuVisible.value = true;
}

function hideSubmenu() {
  submenuVisible.value = false;
}

function openAndScroll(href) {
  hideSubmenu();
  const serviceId = href.substring(1);

  router.push({ name: 'home', hash: '#services' });

  const removeGuard = router.afterEach(() => {
    const event = new CustomEvent('activate-service', {
      detail: { serviceId }
    });

    setTimeout(() => {
      window.dispatchEvent(event);
      removeGuard();
    }, 10);
  });
}
</script>
